// TODO: Delete this FF after new PII API is fully rolled out
const isNewPiiDataEnabled = () => {
  return process.env.REACT_APP_USE_NEW_PII_API === 'true';
};

// TODO: Delete this FF after Regula verification is fully rolled out
const isRegulaEnabled = () => {
  return process.env.REACT_APP_USE_REGULA_VERIFICATION === 'true';
};

const isSsoEnabled = () => process.env.REACT_APP_DISABLE_SSO !== 'true';

export { isNewPiiDataEnabled, isRegulaEnabled, isSsoEnabled };
